import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IQualificationDeprecatedService } from '@agent/core/contact/qualification-deprecated.service';
import { IConferenceDeprecatedService } from '@agent/core/phone/conference/conference-deprecated.service';
import { IContact } from '@commons/models/contact';
import { IPromise, isDefined } from 'angular';

import { Option, Qualification } from '@contact/upgrade';

export interface IPhoneActionsService {
  getCallQualityRate(responseId: string): number;

  updateCallQualityRate(responseId: string, rate: number): void;

  setIsRatingCallQualityEnabled(isEnabled: boolean): void;

  getIsRatingCallQualityEnabled(): boolean;

  hangUp(contact: IContact): IPromise<any>;

  accept(contact: IContact): IPromise<any>;

  refuse(contact: IContact, reason?: string): IPromise<any>;

  parkContact(contact: IContact): IPromise<any>;

  unparkContact(contact: IContact): IPromise<any>;

  finishQualification(responseId: string): IPromise<any>;

  renewPostTreatment(responseId: string): IPromise<any>;

  canSaveQualificationOnHangUp(qualification: Qualification): boolean;

  finish(responseId: string): void;
}

export class PhoneActionsService implements IPhoneActionsService {
  static $inject: Array<string> = ['contactDeprecatedService', 'conferenceDeprecatedService', 'qualificationDeprecatedService'];

  // call quality rate by response identifier index.
  private callQualityRatesIndex: { [responseId: string]: number } = {};
  private isRatingCallQualityEnabled: boolean = false;

  constructor(
    private readonly contactDeprecatedService: IContactDeprecatedService,
    private readonly conferenceDeprecatedService: IConferenceDeprecatedService,
    private readonly qualificationDeprecatedService: IQualificationDeprecatedService
  ) {}

  getCallQualityRate(responseId: string): number {
    if (isDefined(this.callQualityRatesIndex[responseId])) {
      return this.callQualityRatesIndex[responseId];
    } else {
      return -1;
    }
  }

  updateCallQualityRate(responseId: string, rate: number): void {
    this.callQualityRatesIndex[responseId] = rate;
  }

  setIsRatingCallQualityEnabled(isEnabled: boolean): void {
    this.isRatingCallQualityEnabled = isEnabled;
  }

  getIsRatingCallQualityEnabled(): boolean {
    return this.isRatingCallQualityEnabled;
  }

  hangUp(contact: IContact): IPromise<any> {
    return this.contactDeprecatedService.hangUp(contact.responseId);
  }

  accept(contact: IContact): IPromise<any> {
    return this.contactDeprecatedService.accept(contact.responseId);
  }

  refuse(contact: IContact, reason: string = 'refuse'): IPromise<any> {
    return this.contactDeprecatedService.refuse(contact.responseId, reason);
  }

  parkContact(contact: IContact): IPromise<any> {
    return this.conferenceDeprecatedService.parkContact(contact.responseId);
  }

  unparkContact(contact: IContact): IPromise<any> {
    return this.conferenceDeprecatedService.unparkContact(contact.responseId);
  }

  finishQualification(responseId: string): IPromise<any> {
    return this.qualificationDeprecatedService.finishQualification(responseId);
  }

  renewPostTreatment(responseId: string): IPromise<any> {
    return this.qualificationDeprecatedService.renewPostTreatment(responseId);
  }

  /**
   * Return true if there are a qualification form and if the post-qualif duration is zero.
   * In this case, the HangUp action must save the form (if possible)
   * @param contact
   */
  canSaveQualificationOnHangUp(qualification: Qualification) {
    return Option.of(qualification)
      .map(p => p.duration <= 0 && p.fields.length > 0)
      .getOrElse(false);
  }

  finish(responseId: string): void {
    this.contactDeprecatedService.getSelectedQualif().then(qualification => {
      if (!qualification) {
        return;
      }
      this.finishQualification(responseId);
    });
  }
}

export default 'phoneActions';
